export default __webpack_public_path__ + "static/intro_reversed-9e17d9470f836f6b364c7ede523ee7cf.mp4";